<template>
  <a-modal v-model="visible" width="70%">
    <div slot="footer">
      <a-button type="default" @click="() => visible = false">{{ $t('取消') }}</a-button>
      <a-button type="primary" :loading="loading" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('父目录')">
        <a-input v-model="form.parentName" disabled />
      </a-form-model-item>
      <a-form-model-item :label="$t('目录名称')" prop="name">
        <a-input v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item :label="$t('权限字符')" prop="roleKeys">
        <a-input v-model="form.roleKeys" />
      </a-form-model-item>
      <a-form-model-item :label="$t('图标')" prop="icon">
        <a-upload accept="image/*" :customRequest="handleUploadLogo" listType="picture-card" :fileList="logoList" @change="handleLogoChange" @preview="handleLogoPreview">
          <a-button type="primary" v-if="logoList.length == 0">{{ $t('选择图标') }}</a-button>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item :label="$t('排序')" prop="sort">
        <a-input-number :min="1" :precision="0" v-model="form.sort" />
      </a-form-model-item>
    </a-form-model>
    <a-modal v-model="previewVisible" :footer="null">
      <img style="width: 100%" :src="logoUrl" />
    </a-modal>
  </a-modal>
</template>
<script>
import { saveFolder } from '@/api/app/folder'
import { uploadFile, getDownloadUrl } from '@/api/file/file'

export default {
  data() {
    return {
      visible: false,
      loading: false,
      previewVisible: false,
      form: {},
      logoList: [],
    }
  },
  computed: {
    logoUrl() {
      const logoList = this.logoList.filter(e => e.status === 'done')
      if (logoList.length === 0) {
        return null
      }
      const logo = logoList[0]
      const fileId = logo.response.id
      return getDownloadUrl(fileId)
    },
    rules() {
      return {
        name: [
          { required: true, message: this.$t('请输入') }
        ]
      }
    }
  },
  methods: {
    show(data) {
      this.form = { ...data, parentName: data.parentName || this.$t('无') }
      this.logoList = this.form.icon ? [{
        uid: this.form.icon,
        name: 'logo',
        status: 'done',
        response: { id: this.form.icon },
        url: getDownloadUrl(this.form.icon)
      }] : []
      this.visible = true
    },
    handleUploadLogo(file) {
      file.onProgress()
      uploadFile(file.file).then(res => {
        if (res.code === 0) {
          file.onSuccess(res.data)
          this.form.icon = res.data.id
        } else {
          file.onError(res.message)
          this.$message.error(res.message)
        }
      }).catch(e => {
        file.onError(e)
      })
    },
    handleLogoChange(data) {
      const fileList = data.fileList
      fileList.forEach(f => {
        if (f.status === 'done') {
          f.url = getDownloadUrl(f.response.id)
        }
      })
      this.logoList = fileList
    },
    handleLogoPreview() {
      this.previewVisible = true
    },
    handleCommit() {
      this.$refs.form.validate((success, fields) => {
        if (!success) {
          return
        }
        this.loading = true
        const commitData = {
          id: this.form.id,
          name: this.form.name,
          nameEn: this.form.nameEn,
          appId: this.form.appId,
          roleKeys: this.form.roleKeys,
          parentId: this.form.parentId,
          ruleType: '0',
          sort: this.form.sort,
          icon: this.form.icon
        }
        saveFolder(commitData).then(res => {
          if (res.code === 0) {
            this.$emit('ok')
            this.$message.success(this.$t('保存成功'))
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>